import React, { useState } from "react";
import { View, StyleSheet } from "react-native";

import { Text, Toast, Button } from "components";

import { useChmod } from "hooks";
import { useRecoilValue } from "recoil";
import { factorStepsAtom } from "stores";
import { colors } from "assets/constants";

interface StepChangerProps {
  onChange?: (step: FactorStatusT) => void;
  defaultStepPriority?: number;
}

const StepChanger: React.FC<StepChangerProps> = ({
  onChange,
  defaultStepPriority,
}) => {
  const { chmod } = useChmod();
  const steps = useRecoilValue(factorStepsAtom);

  const [activeStepPriority, setActiveStepPriority] = useState(
    defaultStepPriority + 1
  );

  const _onPrev = () => {
    if (activeStepPriority === 1) {
      return;
    }

    if (
      !chmod("factor", "BACK") &&
      activeStepPriority === defaultStepPriority
    ) {
      Toast.warning({
        message: "برای بازگشت به مرحله قبل، نیاز به مجوز مدیر دارید",
      });
      return;
    }

    const newStepPriority = activeStepPriority - 1;
    setActiveStepPriority(newStepPriority);
    onChange(steps[newStepPriority - 1]);
  };

  const _onNext = () => {
    if (steps?.length === activeStepPriority) {
      return;
    }

    const newStepPriority = activeStepPriority + 1;
    setActiveStepPriority(newStepPriority);
    onChange(steps[newStepPriority - 1]);
  };

  return (
    <View style={styles.container}>
      <Button
        onPress={_onNext}
        square={35}
        bgColor={colors.transparent}
        icon={{ name: "chevron-left", color: colors.theme, size: 22 }}
      />
      <View style={styles.title}>
        <Text weight="extraBold" size={"sm"}>
          {steps[activeStepPriority - 1]?.title}
        </Text>
      </View>
      <Button
        onPress={_onPrev}
        square={35}
        bgColor={colors.transparent}
        icon={{ name: "chevron-right", color: colors.theme, size: 22 }}
      />
    </View>
  );
};

export default StepChanger;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },

  title: {
    width: 80,
    height: 37,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.lightButtons,
  },
});
